module.exports = __webpack_public_path__ + "img/certificate-4-lg@3x.dc69e08a.png";